/**
 * Percorsi degli asset di marca, in un unico posto.
 *
 * Questo modulo non importa nulla di proposito: viene usato anche dalla sidebar
 * e dalle pagine di login, e un import di `letterheadPdf.ts` (che carica jsPDF)
 * trascinerebbe la libreria PDF nel bundle d'ingresso.
 */

/** Marchio quadrato Abruzzo.AI. */
export const BRAND_MARK = '/marchio-abruzzoai.png';

/** Logotipo esteso Abruzzo.AI, per header larghi (email, intestazioni PDF). */
export const BRAND_WORDMARK = '/logotipo-abruzzoai.png';

/** Logo del gestionale Pixel. */
export const APP_LOGO = '/logo-pixel.png';

/** Icona dell'app (favicon, manifest PWA). */
export const APP_ICON = '/pixel-icon.png';
